import { RequestBaseSet, ResponseBaseSet } from "@myapp/modules/fwcore/models/messages";
import { DealItemDataChanges } from "src/app/features/prob/models/deal-item-data-changes";
import { DealItemSummary } from "../deal-item-summary";

export class RequestDealCalculateSet extends RequestBaseSet<DealItemDataChanges> {

  /**
   * Required, gets or sets the deal identifier.
   */
  dealId?: string | null;

  /**
   * Required, apply changes to live or to the users' draft store.
   */
  isLive?: boolean | null = true;

  /**
   * After processing the rate item updates, calculate the overall deal based on the precalculated deal item values.
   */
  calculateDeal?: boolean | null;

  /**
   * After processing the rate item updates, calculate the values for the deal items, but NOT the deal totals.
   */
  calculateDealItems?: boolean | null;

  /**
   * Optional, remove values from the users' workspace for the whole deal both rate item and deal values.
   * Note, this will automatically occur if performing an isLive set to true operation.
   * Individual deal items can also be cleared by setting the clear changes on the deal item.
   */
  clearUserChanges?: boolean | null;

  /**
   * If set to true, do not return any changes in the response.
   */
  excludeChanges?: boolean | null;

  /**
   * Gets or sets a default time segment to use if not specified in the data.
   * This is one based and by default if not specified will be set to one.
   */
  timeSegmentDefault?: number | null;

  /**
   * Gets or sets whether calculation is allowed for this request.
   */
  allowCalculate?: boolean | null;

  /**
   * Do not make any changes to the last calculated on field
   * We might be requesting the addition of a new deal item to a deal
   */
  skipCalculatedOn?: boolean | null;

  /**
   * Optional, return deal values for the deal items after completion
   */
  returnValuesForDealItemIds?: string[] | null;

  /// <summary>
  /// Send as true when the blended switch id off.
  /// </summary>
  deleteBlendedRates?: boolean | null;

  /**
   * Was this initiated by the user
   */
  isUserAction?: boolean | null;

}

export class ResponseDealCalculateSet extends ResponseBaseSet<DealItemDataChanges> {

  /**
   * Gets or sets if the data was applied to live or the users' workspace.
   */
  isLive?: boolean | null;

  /**
   * If set to true, do not return any changes in the response.
   */
  excludeChanges?: boolean | null;

  dealItems?: DealItemSummary[] | null | undefined;
}
